import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {CommonService} from 'src/app/shared/utils/common.service';
import {moduloHorasExtras} from "../diccionarios/horas-extrasModulo";

@Injectable({
  providedIn: 'root'
})
export class VerificacionTalentoHumanoService {

  diccionarioModulo: any;
  url: string;

  constructor(
    private http: HttpClient,
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.diccionarioModulo = moduloHorasExtras;
    this.url = this._util.getUrlHorasExtra();
  }


  getAllEmployeesByDepartment(payload) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.getAllEmployeesByDepartment + payload.department);
  }

  getAllEmployees() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.getAllEmployees);
  }

  getAllDepartment() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.getAllDepartment);
  }

  getAllCalculateRRHH(payload) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.verificacionTalentoHumano.getAllCalculateRRHH + '?anio=' + payload.year + '&departmentCode=' + payload.department + '&numero=' + payload.number + '&tipoCalculo=' + payload.type);
  }

  getAllSegundaVerificacion(payload) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.verificacionTalentoHumano.getAllSegundaVerificacion + '?anio=' + payload.year + '&mes=' + payload.week);
  }

  getAll(payload: any) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.verificacionTalentoHumano.getAllCalculate + '?anio=' + payload.year + '&numero=' + payload.number + '&tipoCalculo=' + payload.type); //-Mes- Semana
  }

  getAllReport(payload: any) {
    const department = payload.department !== undefined ? `&departmentCode=${payload.department}` : ``;
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.verificacionTalentoHumano.getAllCalculateReport + '?anio=' + payload.year + '&numero=' + payload.number + '&tipoCalculo=' + payload.type + department);//-Mes- Semana
  }

  getAllByMont(payload) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.verificacionTalentoHumano.getAllMonthly + '?anio=' + payload.year + '&mes=' + payload.week);
    //+ '&departmentCode=' + payload.department
  }

  getAllByWeek(payload) {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.horasExtras.verificacionTalentoHumano.getAllWeekly + '?anio=' + payload.year + '&semana=' + payload.week);
    //+ '&departmentCode=' + payload.department
  }

  procesarHorasExtras(payload) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.horasExtras.verificacionTalentoHumano.procesarHorasExtras, payload);
  }

  procesarHorasExtrasSegundaVerificacion(payload) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.horasExtras.verificacionTalentoHumano.segundaVerificacion, payload);
  }

  actualizarMarcacion(payload) {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.update + payload.id, payload);
    //return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.horasExtras.modificacionMarcacion.update, payload);
  }
}
